import React from 'react';
import { Box, Typography } from '@mui/material';
import WorkFeedbackItem from './WorkFeedbackItem';

const WorkFeedbackSection = ({ section }) => {
  return (
    <Box sx={{ border: '1px solid #ddd', borderRadius: '8px', p: 2, mb: 2 }}>
      <Typography variant="h4" gutterBottom>
        {section.title}
      </Typography>
      {section.questions.map((question, index) => (
        <WorkFeedbackItem key={index} question={question} />
      ))}
    </Box>
  );
};

export default WorkFeedbackSection;
